const CardHeaderBackgroundComponent = ({ title, children }: { title: string, children: JSX.Element }) => {

    return (
        <div className="row gx-5">
            <div className="col-xl-12 col-lg-12 mb-5">
                <div className="card card-raised h-100 overflow-hidden">
                    <div className="card-header bg-primary text-white px-4"><div className="fw-500">{title}</div></div>
                    <div className="card-body mt-3">
                       {children}
                    </div>
                </div>
            </div>
        </div>
    )

}

export default CardHeaderBackgroundComponent;